import dayjs from "dayjs";

export type FieldColumn = {
  key: string;
  value: string;
  locked?: boolean;
  minWidth?: number;
  align?: "left" | "center" | "right";
};

export const INSURANCE_TABLE_SEGMENT = "Insurance";

export const INSURANCE_SUMMARY_REPORT = "Insurance Summary";
export const INSURANCE_DUE_DATE_REPORT = "Due date in next 30 days";

/** Optional columns hidden by default — matching aumsampaan INSURANCE_OPTIONAL_COLUMN_KEYS */
export const INSURANCE_OPTIONAL_COLUMN_KEYS = new Set([
  "nominee",
  "nextPremiumAmount",
  "purchaseDate",
]);

export const INSURANCE_REPORT_TYPE_OPTIONS = [
  { value: INSURANCE_SUMMARY_REPORT, label: INSURANCE_SUMMARY_REPORT },
  { value: INSURANCE_DUE_DATE_REPORT, label: INSURANCE_DUE_DATE_REPORT },
] as const;

export const INSURANCE_QUICK_REPORTS = [
  {
    id: "insurance-summary",
    label: INSURANCE_SUMMARY_REPORT,
    reportType: INSURANCE_SUMMARY_REPORT,
  },
  {
    id: "due-date",
    label: INSURANCE_DUE_DATE_REPORT,
    reportType: INSURANCE_DUE_DATE_REPORT,
  },
];

export const INVESTOR_COLUMN: FieldColumn = {
  key: "investorDisplay",
  value: "Investor Name",
  locked: true,
  minWidth: 200,
};

/** aumsampaan INSURANCE_REPORT_COLUMNS */
export const INSURANCE_BASE_COLUMNS: FieldColumn[] = [
  { key: "insuranceType", value: "Insurance Type", locked: true, minWidth: 140 },
  { key: "policyName", value: "Policy Name", locked: true, minWidth: 200 },
  { key: "policyNumber", value: "Policy No.", minWidth: 120 },
  { key: "insuredName", value: "Insured Name", minWidth: 160 },
  { key: "sumAssured", value: "Sum Assured", minWidth: 128 },
  { key: "firstPremium", value: "First Premium", minWidth: 128 },
  { key: "nextPremiumDue", value: "Next Premium Due Date", minWidth: 160 },
  { key: "maturityDate", value: "Maturity Date", minWidth: 112 },
  { key: "nominee", value: "Nominee", minWidth: 120 },
  { key: "nextPremiumAmount", value: "Next Premium Amt", minWidth: 140 },
  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },
];

export const isInsuranceSummaryReport = (reportType: string): boolean =>
  reportType === INSURANCE_SUMMARY_REPORT;

export const isInsuranceDueDateReport = (reportType: string): boolean =>
  reportType === INSURANCE_DUE_DATE_REPORT;

/** Insurance reports do not require a user-selected date range. */
export const reportTypeNeedsDateRange = (_reportType: string): boolean => false;

export const buildDueReportDateRange = (): { startDate: number; endDate: number } => ({
  startDate: dayjs().startOf("day").valueOf(),
  endDate: dayjs().add(1, "month").endOf("day").valueOf(),
});
